<!-- candidate-list skeleton card code -->
 @if(candidateListLoader){
 @for(sk of [0,1,2,3,4,5]; track sk) {
<div class="skeleton-page mb-2">

  <!-- ── Toolbar Row ── -->
  <div class="toolbar">
    <div class="toolbar-left">
      <div class="sk-box checkbox"></div>
      <div class="sk-box title-bar"></div>
      <div class="toolbar-actions">
        <div class="sk-box icon-btn"></div>
        <div class="sk-box icon-btn"></div>
      </div>
    </div>
    <div class="toolbar-right">
      <div class="sk-box btn-lg"></div>
      <div class="sk-box btn-md"></div>
    </div>
  </div>

  <!-- ── Subtitle / breadcrumb ── -->
  <div class="subtitle-row">
    <div class="sk-box subtitle"></div>
  </div>

  <!-- ── Breadcrumb tags ── -->
  <div class="breadcrumb-row">
    <div class="sk-box crumb crumb--lg"></div>
    <div class="sk-box dot"></div>
    <div class="sk-box crumb crumb--sm"></div>
    <div class="sk-box dot"></div>
    <div class="sk-box crumb crumb--md"></div>

  </div>

  <div class="divider"></div>

  <!-- ── Filter chips row ── -->
  <div class="chips-row">
    <div class="sk-box chip-label"></div>
    @for (c of chips; track $index) {
      <div class="sk-box chip" [style.width.px]="chipWidths[$index]"></div>
    }
  </div>

  <!-- ── Data rows ── -->
  <div class="data-rows">
    @for (r of rows; track $index) {
      <div class="data-row">
        <!-- <div class="sk-box checkbox"></div> -->
        <div class="row-content">
          <!-- <div class="sk-box row-title" [style.width.px]="rowTitleWidths[$index]"></div> -->
          <div class="row-meta">
            <div class="sk-box meta-tag" [style.width.px]="rowMeta1Widths[$index]"></div>
            <div class="sk-box dot"></div>
            <div class="sk-box meta-tag" [style.width.px]="rowMeta2Widths[$index]"></div>
            <div class="sk-box dot"></div>
            <div class="sk-box meta-tag" [style.width.px]="rowMeta3Widths[$index]"></div>
            <div class="sk-box dot"></div>
            <div class="sk-box meta-tag" [style.width.px]="rowMeta4Widths[$index]"></div>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="divider"></div>

  <!-- ── Footer / pagination row ── -->
  <div class="footer-row">
    <div class="d-flex gap-3">
    @for (f of footerCards; track $index) {
      <div class="sk-box footer-card" [style.width.px]="footerWidths[$index]"></div>
    }
    </div>
    <div class="button">
      <div class="button-child">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="28" viewBox="0 0 16 28" fill="none">
          <path d="M0 28V2.8V0L16 14L0 28Z" fill="white"/>
        </svg>
      </div>
    </div>
  </div>

</div>
 }
}
<!-- candidate-list skeleton card code end-->

<!-- project details  -->
<!-- <div class="skeleton-page mb-2">
  <div class="mb-3">
    <div class="sk-box chip-label mb-2"></div>
    <div class="p-2 mb-2" style="border: 1px solid #f2f2f2; border-radius: 4px;">
      <div class="sk-box subtitle"></div>
    </div>
    <div class="d-flex gap-1 align-items-center">
      <div class="sk-box checkbox" style="height: 12px; width: 12px;"></div>
      <div class="sk-box chip-label" style="height: 6px;"></div>
    </div>
  </div>
  <div class="mb-3">
    <div class="sk-box chip-label mb-2"></div>
    <div class="p-2 mb-2" style="border: 1px solid #f2f2f2; border-radius: 4px;">
      <div class="sk-box subtitle"></div>
    </div>
    <div class="d-flex gap-1 align-items-center">
      <div class="sk-box checkbox" style="height: 12px; width: 12px;"></div>
      <div class="sk-box chip-label" style="height: 6px;"></div>
    </div>
  </div>
  <div class="d-flex gap-3 w-100">
    <div class="w-50">
      <div class="sk-box chip-label mb-2"></div>
      <div class="p-2 mb-2 w-100" style="border: 1px solid #f2f2f2; border-radius: 4px;">
        <div class="sk-box subtitle" style="width: 40%;"></div>
      </div>
    </div>
    <div class="w-50">
      <div class="sk-box chip-label mb-2"></div>
      <div class="p-2 mb-2 w-100" style="border: 1px solid #f2f2f2; border-radius: 4px;">
        <div class="sk-box subtitle" style="width: 40%;"></div>
      </div>
    </div>
  </div>
  <div class="sk-box title-bar mb-3"></div>
  <div class="d-flex w-100 align-items-center gap-3 mb-3">
    <div class="w-50">
      <div class="sk-box chip-label mb-2"></div>
      <div class="d-flex w-100 align-items-center gap-1">
        <div class="sk-box chip-label" style="width: 30px;"></div>
        <div class="p-2 w-50" style="border: 1px solid #f2f2f2; border-radius: 4px;">
          <div class="sk-box subtitle" style="width: 30%;"></div>
        </div>
        <div class="sk-box chip-label" style="width: 20px;"></div>
        <div class="p-2 w-50" style="border: 1px solid #f2f2f2; border-radius: 4px;">
          <div class="sk-box subtitle" style="width: 30%;"></div>
        </div>
      </div>
    </div>
    <div class="w-50">
      <div class="sk-box chip-label mb-2"></div>
      <div class="p-2 w-100" style="border: 1px solid #f2f2f2; border-radius: 4px;">
        <div class="sk-box subtitle" style="width: 40%;"></div>
      </div>
    </div>
  </div>
    <div class="mb-3">
      <div class="sk-box chip-label mb-2"></div>
      <div class="p-2 mb-2" style="border: 1px solid #f2f2f2; border-radius: 4px;">
        <div class="sk-box subtitle"></div>
      </div>
      <div class="d-flex gap-1 align-items-center">
        <div class="sk-box checkbox" style="height: 12px; width: 12px;"></div>
        <div class="sk-box chip-label" style="height: 6px;"></div>
      </div>
    </div>
    <div class="mb-3">
      <div class="sk-box chip-label mb-2"></div>
      <div class="p-2 mb-2" style="border: 1px solid #f2f2f2; border-radius: 4px;">
        <div class="sk-box subtitle"></div>
      </div>
    </div>
  <div class="sk-box title-bar mb-3" style="width: 150px;"></div>

  <div class="sk-box title-bar mb-3"></div>

</div> -->
<!-- project details end -->

<!-- proeject deatils side panel card -->
 <!-- <div class="skeleton-page mb-2">
  <div class="mb-3">
    <div class="sk-box chip-label mb-2"></div>
    <div class="sk-box title-bar" style="width:100px"></div>
  </div>
  <div class="mb-3">
    <div class="sk-box chip-label mb-2"></div>
    <div class="sk-box title-bar" style="width:120px"></div>
  </div>
  <div class="mb-3">
    <div class="sk-box chip-label mb-2"></div>
    <div class="d-flex gap-2">

      <div class="sk-box title-bar" style="width:50px"></div>
      <div class="sk-box title-bar" style="width:50px"></div>
    </div>
  </div>
    <div class="sk-box chip-label mb-2" style="width: 100px;"></div>
    <div class="sk-box chip-label mb-2" style="width: 150px;"></div>
 </div> -->
<!-- proeject deatils side panel card end-->
<!-- slider table skeleton -->
 @if(showExplanationLoader) {
<div class="table-sk-view">
  <div class="table-sk-header">
    <div class="table-sk-col">
          <div class="sk-box chip-label" style="height: 6px; width: 121px;"></div>
      </div>
      <div class="table-sk-col">
          <div class="sk-box chip-label" style="height: 6px; width: 30%;"></div>
      </div>
  </div>
  <div class="table-body-row">
    <div class="table-sk-col">
          <div class="sk-box chip-label" style="height: 6px; width: 30%;"></div>
    </div>
    <div class="table-sk-col">
          <div class="sk-box chip-label" style="height: 6px; width: 50%;"></div>
    </div>
  </div>
    <div class="table-body-row">
    <div class="table-sk-col">
          <div class="sk-box chip-label" style="height: 6px; width: 40%;"></div>
    </div>
    <div class="table-sk-col">
          <div class="sk-box chip-label" style="height: 6px; width: 70%;"></div>
    </div>
  </div>
    <div class="table-body-row">
    <div class="table-sk-col">
          <div class="sk-box chip-label" style="height: 6px; width: 20%;"></div>
    </div>
    <div class="table-sk-col">
          <div class="sk-box chip-label" style="height: 6px; width: 40%;"></div>
    </div>
  </div>
    <div class="table-body-row">
    <div class="table-sk-col">
          <div class="sk-box chip-label" style="height: 6px; width: 30%;"></div>
    </div>
    <div class="table-sk-col">
          <div class="sk-box chip-label" style="height: 6px; width: 60%;"></div>
    </div>
  </div>
  <div class="table-body-row">
    <div class="table-sk-col">
          <div class="sk-box chip-label" style="height: 6px; width: 20%;"></div>
    </div>
    <div class="table-sk-col">
          <div class="sk-box chip-label" style="height: 6px; width: 70%;"></div>
    </div>
  </div>
 </div>

 }
<!-- slider table skeleton end-->
 <!-- slider table with 3 column skeleton -->
  @if(showJDFitLoader) {
 <div class="table-sk-3-column-view">
  <div class="table-sk-header">
    <div class="table-sk-3-col">
          <div class="sk-box chip-label" style="height: 6px; width: 121px;"></div>
      </div>
      <div class="table-sk-3-col">
          <div class="sk-box chip-label" style="height: 6px; width: 30%;"></div>
      </div>
      <div class="table-sk-3-col">
          <div class="sk-box chip-label" style="height: 6px; width: 30%;"></div>
      </div>
  </div>
  <div class="table-body-row">
    <div class="table-sk-3-col">
          <div class="sk-box chip-label" style="height: 6px; width: 30%;"></div>
    </div>
    <div class="table-sk-3-col">
          <div class="sk-box chip-label" style="height: 6px; width: 50%;"></div>
    </div>
     <div class="table-sk-3-col">
          <div class="sk-box chip-label" style="height: 6px; width: 50%;"></div>
    </div>
  </div>
    <div class="table-body-row">
    <div class="table-sk-3-col">
          <div class="sk-box chip-label" style="height: 6px; width: 40%;"></div>
    </div>
    <div class="table-sk-3-col">
          <div class="sk-box chip-label" style="height: 6px; width: 70%;"></div>
    </div>
     <div class="table-sk-3-col">
          <div class="sk-box chip-label" style="height: 6px; width: 70%;"></div>
    </div>
  </div>
    <div class="table-body-row">
    <div class="table-sk-3-col">
          <div class="sk-box chip-label" style="height: 6px; width: 20%;"></div>
    </div>
    <div class="table-sk-3-col">
          <div class="sk-box chip-label" style="height: 6px; width: 40%;"></div>
    </div>
     <div class="table-sk-3-col">
          <div class="sk-box chip-label" style="height: 6px; width: 40%;"></div>
    </div>
  </div>
    <div class="table-body-row">
    <div class="table-sk-3-col">
          <div class="sk-box chip-label" style="height: 6px; width: 30%;"></div>
    </div>
    <div class="table-sk-3-col">
          <div class="sk-box chip-label" style="height: 6px; width: 60%;"></div>
    </div>
     <div class="table-sk-3-col">
          <div class="sk-box chip-label" style="height: 6px; width: 60%;"></div>
    </div>
  </div>
  <div class="table-body-row">
    <div class="table-sk-3-col">
          <div class="sk-box chip-label" style="height: 6px; width: 20%;"></div>
    </div>
    <div class="table-sk-3-col">
          <div class="sk-box chip-label" style="height: 6px; width: 70%;"></div>
    </div>
     <div class="table-sk-3-col">
          <div class="sk-box chip-label" style="height: 6px; width: 70%;"></div>
    </div>
  </div>
 </div>
}


 <!-- slider table with 3 column skeleton end-->

 <!-- slider table without JD skeleton -->
  @if(showLongSummaryLoader){
 <div class="skeleton-page mb-2">
    <div class="d-flex align-items-center w-100 mb-2">
      <div class="mr-1" style="width: 20px;">
        <div class="checkbox sk-box" style="border-radius: 50%;"></div>
      </div>
      <div style="width: calc(100% - 30px);">
        <div class="sk-box title-bar mb-1" style="width: 40%;"></div>
        <div class="sk-box chip-label mb-1" style="width: 98%;"></div>
        <div class="sk-box chip-label mb-1" style="width: 90%;"></div>
        <div class="sk-box chip-label mb-1" style="width: 80%;"></div>
      </div>
    </div>
    <div class="d-flex align-items-center w-100 mb-2">
      <div class="mr-1" style="width: 20px;">
        <div class="checkbox sk-box" style="border-radius: 50%;"></div>
      </div>
      <div style="width: calc(100% - 30px);">
        <div class="sk-box title-bar mb-1" style="width: 40%;"></div>
        <div class="sk-box chip-label mb-1" style="width: 98%;"></div>
        <div class="sk-box chip-label mb-1" style="width: 90%;"></div>
        <div class="sk-box chip-label mb-1" style="width: 80%;"></div>
      </div>
    </div>
    <div class="d-flex align-items-center w-100 mb-2">
      <div class="mr-1" style="width: 20px;">
        <div class="checkbox sk-box" style="border-radius: 50%;"></div>
      </div>
      <div style="width: calc(100% - 30px);">
        <div class="sk-box title-bar mb-1" style="width: 40%;"></div>
        <div class="sk-box chip-label mb-1" style="width: 98%;"></div>
        <div class="sk-box chip-label mb-1" style="width: 90%;"></div>
        <div class="sk-box chip-label mb-1" style="width: 80%;"></div>
      </div>
    </div>
    <div class="d-flex align-items-center w-100 mb-2">
      <div class="mr-1" style="width: 20px;">
        <div class="checkbox sk-box" style="border-radius: 50%;"></div>
      </div>
      <div style="width: calc(100% - 30px);">
        <div class="sk-box title-bar mb-1" style="width: 40%;"></div>
        <div class="sk-box chip-label mb-1" style="width: 98%;"></div>
        <div class="sk-box chip-label mb-1" style="width: 90%;"></div>
        <div class="sk-box chip-label mb-1" style="width: 80%;"></div>
      </div>
    </div>
    <div class="d-flex align-items-center w-100 mb-2">
      <div class="mr-1" style="width: 20px;">
        <div class="checkbox sk-box" style="border-radius: 50%;"></div>
      </div>
      <div style="width: calc(100% - 30px);">
        <div class="sk-box title-bar mb-1" style="width: 40%;"></div>
        <div class="sk-box chip-label mb-1" style="width: 98%;"></div>
        <div class="sk-box chip-label mb-1" style="width: 90%;"></div>
        <div class="sk-box chip-label mb-1" style="width: 80%;"></div>
      </div>
    </div>
 </div>
}
 <!-- slider table without JD skeleton -->



